import { ArrowRight, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CtaAnchor, CtaLink } from "@/src/common/components/cta-link";
import { SITE_CONFIG } from "@/src/common/constants/site-config";
import { SITE_ROUTES } from "@/src/common/constants/site-routes";

export function LegalContactCard() {
	const { t } = useTranslation("legal");

	return (
		<aside className="no-print mt-16 rounded-3xl border border-brand-200/60 bg-brand-50/60 p-6 md:p-8">
			<div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
				<div>
					<h2 className="text-xl font-semibold text-foreground">{t("contact.title")}</h2>
					<p className="mt-2 max-w-md text-sm text-default-600">{t("contact.description")}</p>
				</div>
				<div className="flex flex-wrap gap-3">
					<CtaLink to={SITE_ROUTES.CONTACT} variant="primary" size="md" endContent={<ArrowRight className="h-4 w-4" />}>
						{t("contact.cta")}
					</CtaLink>
					<CtaAnchor href={`mailto:${SITE_CONFIG.contactEmail}`} variant="outline" size="md" startContent={<Mail className="h-4 w-4" />}>
						{SITE_CONFIG.contactEmail}
					</CtaAnchor>
				</div>
			</div>
		</aside>
	);
}
